import React, { useEffect, useRef, useState } from 'react'
import './style.scss'
import '../../assets/style/main.css'
import PageLoader, {isPageLoading} from '../../components/PageLoader'
import SignIn_Navbar from '../../components/SignIn_Navbar'
import COVER from '../../assets/images/icons/success-icon.png'
import { Base_API } from '../../_actions/matcher'
import { DecryptedText } from '../../utils/Encryption'

function KYC_Identity_Verified() {
    let onceMount = useRef(true);
    let [typeKYC, setTypeKYC] = useState(!!localStorage.getItem(process.env.REACT_APP_ENC_NAME_TYPE_REGIS) ? DecryptedText(localStorage.getItem(process.env.REACT_APP_ENC_NAME_TYPE_REGIS)) : '');

    useEffect(() => {
        if(onceMount.current)
        {
            pageInit();
            onceMount.current = false;
        }
    })

    const pageInit = async() => {
        isPageLoading(false);
    }

    const onSubmit = () => {
        location.href = `${Base_API.pathWeb}/n-health/kyc/step-1`;
    }

    return (
        <div className="kyc-idenvrf-con">
            <SignIn_Navbar/>
            <PageLoader />

            <img className='cover' src={COVER} />        
            <h1 className='header-text'>{typeKYC==='idcard' && 'บัตรประชาชนและ'}ใบหน้าของคุณได้รับการตรวจสอบแล้ว</h1>
            <p className='sub-title'>กรุณายืนยันตัวตนในขั้นตอนถัดไป</p>

            <div className="submit-btn">
                <button onClick={onSubmit}>
                    ยืนยันตัวตนต่อ
                </button>
            </div>

            <div className="copyright">
                <p>© All Rights Reserved. N Health. Managed by NiLECON THAILAND.</p>
            </div>
        </div>
    )
}

export default KYC_Identity_Verified